import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-confirm-virement-refus',
    templateUrl: './confirm-virement-refus.component.html',
    styleUrls: ['./confirm-virement-refus.component.scss'],
    imports: [MatDialogTitle, MatIconButton, MatTooltip, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatDialogActions, MatButton]
})
export class ConfirmVirementRefusComponent implements OnInit {
  public formulaireRefus: FormGroup = new FormGroup({});
  public titreModal = 'Refuser la demande';
  public sousTitreModal = 'Voulez-vous vraiment refuser la demande de mouvement ?';

  constructor(
    public dialog: MatDialogRef<ConfirmVirementRefusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    if (data.nb > 1) {
      this.titreModal = 'Refuser les demandes';
      this.sousTitreModal = 'Voulez-vous vraiment refuser les demandes de mouvement ?';
    }
  }

  ngOnInit(): void {
    this.formulaireRefus = this.fb.group({
      motif: ['']
    });
  }

  enregistrerRefus(): void {
    this.dialog.close(this.formulaireRefus.get('motif')?.value);
  }
}
